import style from "css/hotdesking.module.css";
import React, { useCallback, useEffect, useState } from "react";
import {
  EnvironmentOutlined,
  SearchOutlined,
  StarFilled,
  StarOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import axios from "axios";
import HotdeskingConfig from "../Config";
import { Avatar, ConfigProvider, Input, Tabs } from "antd";
import Loading from "./Loading";
import { useTranslation } from "react-i18next";

function UserMenu({ onShowBook }) {
  const { t } = useTranslation();
  const tabList = [
    {
      key: "favorite",
      label: t("HOTDESKING.MENU.TEAM.BUTTON.FAVORITE"),
      icon: <StarOutlined className={style.tab_icon} />,
    },
    {
      key: "basic",
      label: t("HOTDESKING.MENU.TEAM.BUTTON.SEARCH"),
      icon: <SearchOutlined className={style.tab_icon} />,
    },
    {
      key: "department",
      label: t("HOTDESKING.MENU.TEAM.BUTTON.MY_TEAM"),
      icon: <TeamOutlined className={style.tab_icon} />,
    },
  ];
  const [init, setInit] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [tab, setTab] = useState("favorite");
  const [memberList, setMemberList] = useState([]);
  const [text, setText] = useState("");

  const onSearch = useCallback(() => {
    const config = {
      params: {
        search_type: tab,
      },
    };
    axios
      .get(`${HotdeskingConfig.baseURI}/member`, config)
      .then((res) => {
        setMemberList(res.data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [tab]);

  const onSearchText = useCallback(() => {
    if (text === "") {
      setIsLoading(false);
      return;
    }

    const config = {
      params: {
        search_type: tab,
        search_text: text,
      },
    };
    axios
      .get(`${HotdeskingConfig.baseURI}/member`, config)
      .then((res) => {
        if (res.data.length > 0) {
          setMemberList(res.data);
        } else {
          setMemberList([]);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [tab, text]);

  useEffect(() => {
    if (init) {
      switch (tab) {
        case "basic":
          onSearchText();
          break;
        case "favorite":
          onSearch();
          break;
        case "department":
          onSearch();
          break;
        default:
          break;
      }
      setInit(false);
    }
  }, [init, onSearch, onSearchText, tab]);

  //즐겨찾기 생성
  const onAddFavorite = (id) => {
    const data = {
      member_id: id,
    };
    axios.post(`${HotdeskingConfig.baseURI}/member/favorite`, data).then(() => {
      if (tab === "basic") {
        onSearchText();
      } else {
        onSearch();
      }
    });
  };
  //즐겨찾기 삭제
  const onCancelFavorite = (id) => {
    setIsLoading(true);
    const config = {
      params: {
        member_id: id,
      },
    };
    axios
      .delete(`${HotdeskingConfig.baseURI}/member/favorite`, config)
      .then(() => {
        if (tab === "basic") {
          onSearchText();
        } else {
          onSearch();
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const onChangeTab = (key) => {
    setIsLoading(true);
    setMemberList([]);
    setText("");
    setTab(key);
    setInit(true);
  };
  const renderTabBar = (props, DefaultTabBar) => (
    <DefaultTabBar {...props} className={style.tab_bar} />
  );
  const tabRender = () => {
    switch (tab) {
      case "basic":
        return (
          <SearchTab
            list={memberList}
            text={text}
            setText={setText}
            onSearch={onSearchText}
            onShowBook={onShowBook}
            onAddFavorite={onAddFavorite}
            onCancelFavorite={onCancelFavorite}
          />
        );
      case "favorite":
        return (
          <FavoriteTab
            list={memberList}
            // onSearch={onSearch}
            onShowBook={onShowBook}
            onCancelFavorite={onCancelFavorite}
          />
        );
      case "department":
        return (
          <DepartmentTab
            list={memberList}
            onSearch={onSearch}
            onShowBook={onShowBook}
            onAddFavorite={onAddFavorite}
            onCancelFavorite={onCancelFavorite}
          />
        );
      default:
        <></>;
    }
  };

  return (
    <section className={style.menu_user}>
      <section className={style.user_header}>
        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                itemColor: "#909090",
                itemHoverColor: "#121212",
                itemSelectedColor: "#121212",
                inkBarColor: "#121212",
              },
            },
          }}
        >
          <Tabs
            className={style.tabs}
            activeKey={tab}
            items={tabList}
            renderTabBar={renderTabBar}
            onChange={onChangeTab}
            centered
          />
        </ConfigProvider>
      </section>
      {isLoading ? <Loading /> : tabRender()}
    </section>
  );
}

export default UserMenu;

function SearchTab({
  list,
  text,
  setText,
  onSearch,
  onShowBook,
  onAddFavorite,
  onCancelFavorite,
}) {
  const { t } = useTranslation();
  return (
    <section className={style.user_search}>
      <Input.Search
        enterButton={<SearchOutlined />}
        onPressEnter={onSearch}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onSearch={onSearch}
      />
      <section className={style.user_basic}>
        <section className={style.user_basic_container}>
          {list.length > 0 ? (
            list.map((item, idx) => (
              <div
                className={style.basic_item}
                key={idx}
                onClick={() => {
                  if (item.resource !== undefined) {
                    onShowBook({
                      ...item,
                      member: {
                        department: item.department,
                        id: item.id,
                        name: item.name,
                        role: item.role,
                      },
                    });
                  }
                }}
              >
                <section className={style.info_section}>
                  <Avatar
                    className={style.user_img}
                    icon={<UserOutlined className={style.icon} />}
                  />
                  <article className={style.user_info}>
                    <p className={style.user_name}>{item.name}</p>
                    <div className={style.user_department}>
                      <p>{item.role}</p>
                      <span className={style.driver} />
                      <p>{item.department.name}</p>
                    </div>
                    <div
                      className={
                        item.resource === undefined
                          ? style.user_location
                          : `${style.user_location} ${style.inuse}`
                      }
                    >
                      <EnvironmentOutlined className={style.location_icon} />
                      {item.resource === undefined ? (
                        <p className={style.location_title}>No Workplace</p>
                      ) : (
                        <>
                          <p className={style.location_title}>
                            {item.resource.location.title}
                          </p>
                          <p className={style.location_title}>
                            {item.resource.title}
                          </p>
                        </>
                      )}
                    </div>
                  </article>
                </section>

                {item.favorite ? (
                  <StarFilled
                    className={`${style.favorite_icon} ${style.fill}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      onCancelFavorite(item.id);
                    }}
                  />
                ) : (
                  <StarOutlined
                    className={style.favorite_icon}
                    onClick={(e) => {
                      e.stopPropagation();
                      onAddFavorite(item.id);
                    }}
                  />
                )}
              </div>
            ))
          ) : (
            <section className={style.no_data}>
              <SearchOutlined className={style.no_data_icon} />
              <p className={style.no_data_label}>
                {t("HOTDESKING.MENU.TEAM.MESSAGE.NO_SEARCH")}
              </p>
            </section>
          )}
        </section>
      </section>
    </section>
  );
}
function FavoriteTab({ list, onShowBook, onCancelFavorite }) {
  const { t } = useTranslation();
  return (
    <section className={style.user_favorite}>
      <section className={style.user_favorite_container}>
        {list.length > 0 ? (
          list.map((item, idx) => (
            <div
              className={style.favorite_item}
              key={idx}
              onClick={() => {
                if (item.resource !== undefined) {
                  onShowBook({
                    ...item,
                    member: {
                      department: item.department,
                      id: item.id,
                      name: item.name,
                      role: item.role,
                    },
                  });
                }
              }}
            >
              <section className={style.info_section}>
                <Avatar
                  className={style.user_img}
                  icon={<UserOutlined className={style.icon} />}
                />
                <article className={style.user_info}>
                  <p className={style.user_name}>{item.name}</p>
                  <div className={style.user_department}>
                    <p>{item.role}</p>
                    <span className={style.driver} />
                    <p>{item.department.name}</p>
                  </div>
                  <div
                    className={
                      item.resource === undefined
                        ? style.user_location
                        : `${style.user_location} ${style.inuse}`
                    }
                  >
                    <EnvironmentOutlined className={style.location_icon} />
                    {item.resource === undefined ? (
                      <p className={style.location_title}>No Workplace</p>
                    ) : (
                      <>
                        <p className={style.location_title}>
                          {item.resource.location.title}
                        </p>
                        <p className={style.location_title}>
                          {item.resource.title}
                        </p>
                      </>
                    )}
                  </div>
                </article>
              </section>
              <StarFilled
                className={style.favorite_icon}
                onClick={(e) => {
                  e.stopPropagation();
                  onCancelFavorite(item.id);
                }}
              />
            </div>
          ))
        ) : (
          <section className={style.no_data}>
            <SearchOutlined className={style.no_data_icon} />
            <p className={style.no_data_label}>
              {t("HOTDESKING.MENU.TEAM.MESSAGE.NO_FAVORITE")}
            </p>
          </section>
        )}
      </section>
    </section>
  );
}
function DepartmentTab({ list, onShowBook, onAddFavorite, onCancelFavorite }) {
  const { t } = useTranslation();
  return (
    <section className={style.user_department}>
      <section className={style.user_department_container}>
        {list.length > 0 ? (
          list.map((item, idx) => (
            <div
              className={style.department_item}
              key={idx}
              onClick={() => {
                if (item.resource !== undefined) {
                  onShowBook({
                    ...item,
                    member: {
                      department: item.department,
                      id: item.id,
                      name: item.name,
                      role: item.role,
                    },
                  });
                }
              }}
            >
              <section className={style.info_section}>
                <Avatar
                  className={style.user_img}
                  icon={<UserOutlined className={style.icon} />}
                />
                <article className={style.user_info}>
                  <p className={style.user_name}>{item.name}</p>
                  <div className={style.user_department}>
                    <p>{item.role}</p>
                    <span className={style.driver} />
                    <p>{item.department.name}</p>
                  </div>
                  <div
                    className={
                      item.resource === undefined
                        ? style.user_location
                        : `${style.user_location} ${style.inuse}`
                    }
                  >
                    <EnvironmentOutlined className={style.location_icon} />
                    {item.resource === undefined ? (
                      <p className={style.location_title}>No Workplace</p>
                    ) : (
                      <>
                        <p className={style.location_title}>
                          {item.resource.location.title}
                        </p>
                        <p className={style.location_title}>
                          {item.resource.title}
                        </p>
                      </>
                    )}
                  </div>
                </article>
              </section>

              {item.favorite ? (
                <StarFilled
                  className={`${style.favorite_icon} ${style.fill}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onCancelFavorite(item.id);
                  }}
                />
              ) : (
                <StarOutlined
                  className={style.favorite_icon}
                  onClick={(e) => {
                    e.stopPropagation();
                    onAddFavorite(item.id);
                  }}
                />
              )}
            </div>
          ))
        ) : (
          <section className={style.no_data}>
            <SearchOutlined className={style.no_data_icon} />
            <p className={style.no_data_label}>
              {t("HOTDESKING.MENU.TEAM.MESSAGE.NO_TEAM")}
            </p>
          </section>
        )}
      </section>
    </section>
  );
}
